/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

export const environment = {
	"production": false,
	"logLineNumbers": false,
	"firebase": {
		"projectId": "fayez-touchplan",
		"databaseURL": "https://fayez-touchplan.firebaseio.com",
		"authDomain": "fayez-touchplan.firebaseapp.com",
		"storageBucket": "fayez-touchplan",
		"attachmentBucket": "fayez-touchplan-attachments-bucket",
		"apiKey": "AIzaSyAQsG-ESB2k3HGLq-E4R4bb3_n4HLr9OG4"
	},
	"refUrl": "/Root/",
	"additionalErrorIdentifier": null,
	"defaultUserTier": "individual",
	"segmentKey": "aqHKKwrVC6ACKv307p4gUffGeCcFcrtx",
	"useCloud": true,
	"developerMode": false,
	"restApiUrl": ""
};